<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Forgot Password v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <img
            src="../../../assets/images/logo/logo.svg"
            class="logo-size"
          >
        </b-link>
        <div v-if="input">
          <b-card-title class="mb-1">
            <h3>Esqueceu sua senha ?</h3>
          </b-card-title>
          <b-card-text class="mb-2">
            Introduza o seu e-mail e enviaremos instruções para redefinir a sua senha.
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >

              <!-- email -->
              <b-form-group
                label-for="email"
                label="Email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="userEmail"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Email"
                    class="input-color"
                    autofocus
                    @focus="errorText=null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>

                  <div
                    v-if="errorIsTrue"
                    class="text-danger text-center mb-1 mt-1"
                  >
                    {{ errorText }}
                  </div>
                </validation-provider>
              </b-form-group>
              <!-- submit button -->
              <b-button
                variant="info"
                type="submit"
                block
                :disabled="invalid"
                @click="request()"
              >
                Enviar Email
              </b-button>
            </b-form>
          </validation-observer>
        </div>

        <div v-else>
          <b-col md="12">
            <b-row class="d-flex justify-content-center">
              <b-col
                style="margin-top: -1rem !important"
                md="3"
                cols="12"
              >
                <icon type="success" />
              </b-col>
              <b-col
                md="9"
                cols="12"
              >
                <div class="ml-1 text-center mt-1">
                  <h5>Enviamos um email para você com um link de redefinição de senha</h5>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </div>
        <b-card-text class="text-center mt-2 text-blue">
          <b-link :to="{name:'home'}">
            <span>Voltar</span>
          </b-link>
        </b-card-text>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BRow,
  BCol,
  BCardText,
  BCardTitle,
} from 'bootstrap-vue'
import {
  required,
  email,
} from '@validations'
import {
  togglePasswordVisibility,
} from '@core/mixins/ui/forms'

import { forgotPassword } from '@/service/user/user'
import { callLoading, removeDarkMode } from '@/service/utilities/utilities'

import Icon from '@/layouts/components/Icon.vue'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BLink,
    BRow,
    BCol,
    BCardText,
    BCardTitle,
    Icon,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      status: '',
      required,
      email,
      colorx: '#F37021',
      errorText: null,
      errorIsTrue: false,
      input: true,
    }
  },
  created() {
    removeDarkMode()
  },
  methods: {
    async request() {
      callLoading(true)
      try {
        const response = await forgotPassword(this.userEmail)
        const { status } = response

        if (status === 200) {
          this.input = false
        } else if (status === 422) {
          this.errorText = 'O email inserido não pertence a uma conta. Verifique seu email e tente novamente.'
          this.errorIsTrue = true
        }
      } finally {
        callLoading(false)
      }
    },
  },
}
</script>

<style scoped lang="scss">
  @import '@core/scss/vue/pages/page-auth.scss';
</style>
